import { APIADAPTER_FACTORY_EXPOSE_KEY } from '../../client/src/consts';
import { ADAPTER_NAMES } from '../../client/src/modules/_core/types';
import HttpClient from '../http-client';
import GoodBotFlowChat from './GoodBotFlowChat';
var ADAPTER_NAME = ADAPTER_NAMES.GOODBOT_FLOW;
/**
 * https://docs.partner.borndigital.ai/api_flow.html#interacting-with-flows
 */
function buildGoodBotFlowApiAdapter(config) {
    return new GoodBotFlowChat(new HttpClient(config.URL));
}
// export the builder into the global scope
window[APIADAPTER_FACTORY_EXPOSE_KEY] = window[APIADAPTER_FACTORY_EXPOSE_KEY] || {};
window[APIADAPTER_FACTORY_EXPOSE_KEY][ADAPTER_NAME] = buildGoodBotFlowApiAdapter;
export default buildGoodBotFlowApiAdapter;
